module.exports = __webpack_public_path__ + "img/sravniru.b263022.svg";